module.exports = {
  maps: {
    'b': {name: '買い', name_en: 'buy'},
    's': {name: '売り', name_en: 'sell'},
    'e': {name: 'その他', name_en: 'other'},
  },
}
